export var statusColors = {confirmed:'#2FCF39',pending:'#ffa165',approved:'#ffa165',declined:'#fa4f4b',cancelled:'#72828a',completed:'#00b7e6'};